import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibraryBooksIssuedToChildren = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Books issued to children" />
    </Box>
  );
};
